module.exports = __webpack_public_path__ + "static/media/iPhone14-5.3597dabe.png";